import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AppButton } from '../../../../client/components/atom/app-button/app-button';
import { PublicStylesApiService } from '../../../../../core/api/projects/public-styles-api.service';
import { MainStyleDto } from '../../../../../core/api/_dtos/projects.dto';

@Component({
  selector: 'app-banner-section',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslatePipe, AppButton],
  templateUrl: './banner-section.html',
  styleUrl: './banner-section.scss'
})
export class BannerSection {
  private readonly publicStylesApi = inject(PublicStylesApiService);

  readonly styleOfMonth = signal<MainStyleDto | null>(null);
  readonly styleImageUrl = computed(() => {
    const style = this.styleOfMonth();
    return style?.preview?.full || style?.preview?.preview || style?.media?.full || style?.media?.thumb || null;
  });

  constructor() {
    this.publicStylesApi.getStyleOfMonth().subscribe({
      next: response => this.styleOfMonth.set(response.data),
      error: () => this.styleOfMonth.set(null),
    });
  }
}
